import React from 'react';
import { Container, Card, Row, Col, Alert } from 'react-bootstrap';
import { FaShieldAlt, FaUserLock, FaRegClock, FaTrashAlt, FaShareAlt, FaUserCog, FaCookieBite, FaHeadset, FaBullhorn } from 'react-icons/fa';

const PrivacyPolicy = () => {
  return (
    <Container className="py-5">
      <Card className="border-0 shadow-sm mb-5">
        <Card.Body className="p-md-5">
          {/* 헤더 섹션 */}
          <div className="text-center mb-5">
            <div className="mb-4">
              <FaShieldAlt size={50} color="var(--main-color)" />
            </div>
            <h1 className="mb-3" style={{ color: 'var(--main-color)', fontWeight: '700' }}>개인정보처리방침</h1>
            <p className="text-muted">
              최종 업데이트: {new Date().toLocaleDateString()}
            </p>
          </div>
          
          <Alert variant="light" className="mb-5 border" style={{ backgroundColor: '#f8f9fa' }}>
            <p className="mb-0">
              (주)비나이다컴퍼니(이하 '회사')는 이용자의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호"에 관한 법률을 준수하고 있습니다.
              회사는 개인정보처리방침을 통하여 이용자가 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
            </p>
          </Alert>

          {/* 각 섹션 */}
          <Row>
            <Col lg={12}>
              <div className="policy-section mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div className="me-3" style={{ color: 'var(--main-color)' }}>
                    <FaUserLock size={28} />
                  </div>
                  <h3 className="mb-0">1. 수집하는 개인정보 항목</h3>
                </div>
                
                <div className="ps-md-5 ms-md-2">
                  <p>
                    회사는 회원가입, 상담, 서비스 신청 등등을 위해 아래와 같은 개인정보를 수집하고 있습니다.
                  </p>
                  <Card className="border-light mb-3">
                    <Card.Body>
                      <ul className="mb-0">
                        <li className="mb-2"><strong>수집항목</strong> : 이름, 아이디, 비밀번호, 휴대전화번호, 이메일, 서비스 이용기록, 접속 로그, 쿠키, 접속 IP 정보</li>
                        <li><strong>개인정보 수집방법</strong> : 홈페이지(회원가입), 서면양식, 전화/팩스를 통한 회원가입, 제휴사로부터의 제공</li>
                      </ul>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              
              <div className="policy-section mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div className="me-3" style={{ color: 'var(--main-color)' }}>
                    <FaShareAlt size={28} />
                  </div>
                  <h3 className="mb-0">2. 개인정보의 수집 및 이용목적</h3>
                </div>
                
                <div className="ps-md-5 ms-md-2">
                  <p>
                    회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.
                  </p>
                  <Card className="border-light mb-3">
                    <Card.Body>
                      <ul className="mb-0">
                        <li className="mb-2"><strong>서비스 제공</strong> : 콘텐츠 제공, 구매 및 요금 결제, 물품배송 또는 청구지 등 발송, 금융거래 본인 인증 및 금융 서비스</li>
                        <li className="mb-2"><strong>회원 관리</strong> : 회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인, 불만처리 등 민원처리, 고지사항 전달</li>
                        <li><strong>마케팅 및 광고</strong> : 신규 서비스(제품) 개발 및 특화, 이벤트 등 광고성 정보 전달, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계</li>
                      </ul>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              
              <div className="policy-section mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div className="me-3" style={{ color: 'var(--main-color)' }}>
                    <FaRegClock size={28} />
                  </div>
                  <h3 className="mb-0">3. 개인정보의 보유 및 이용기간</h3>
                </div>
                
                <div className="ps-md-5 ms-md-2">
                  <p>
                    원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 아래와 같이 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.
                  </p>
                  <Card className="border-light mb-3">
                    <Card.Body>
                      <ul className="mb-0">
                        <li className="mb-2"><strong>계약 또는 청약철회 등에 관한 기록</strong> : 5년 (전자상거래등에서의 소비자보호에 관한 법률)</li>
                        <li className="mb-2"><strong>대금결제 및 재화 등의 공급에 관한 기록</strong> : 5년 (전자상거래등에서의 소비자보호에 관한 법률)</li>
                        <li className="mb-2"><strong>소비자의 불만 또는 분쟁처리에 관한 기록</strong> : 3년 (전자상거래등에서의 소비자보호에 관한 법률)</li>
                        <li className="mb-2"><strong>본인확인에 관한 기록</strong> : 6개월 (정보통신망 이용촉진 및 정보보호 등에 관한 법률)</li>
                        <li><strong>웹사이트 방문기록</strong> : 3개월 (통신비밀보호법)</li>
                      </ul>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              
              <div className="policy-section mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div className="me-3" style={{ color: 'var(--main-color)' }}>
                    <FaTrashAlt size={28} />
                  </div>
                  <h3 className="mb-0">4. 개인정보의 파기절차 및 방법</h3>
                </div>
                
                <div className="ps-md-5 ms-md-2">
                  <p>
                    회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.
                  </p>
                  <Card className="border-light mb-3">
                    <Card.Body>
                      <Row>
                        <Col md={6}>
                          <div className="mb-3 mb-md-0">
                            <h5 className="mb-3" style={{ color: 'var(--main-color)' }}>파기절차</h5>
                            <p className="mb-0">회원님이 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라 일정 기간 저장된 후 파기되어집니다.</p>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div>
                            <h5 className="mb-3" style={{ color: 'var(--main-color)' }}>파기방법</h5>
                            <p className="mb-0">전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</p>
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              
              {/* 나머지 섹션들도 위와 같은 스타일로 계속 */}
              <div className="policy-section mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div className="me-3" style={{ color: 'var(--main-color)' }}>
                    <FaShareAlt size={28} />
                  </div>
                  <h3 className="mb-0">5. 개인정보 제공</h3>
                </div>
                
                <div className="ps-md-5 ms-md-2">
                  <p>
                    회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.
                  </p>
                  <Card className="border-light mb-3">
                    <Card.Body>
                      <ul className="mb-0">
                        <li className="mb-2">이용자들이 사전에 동의한 경우</li>
                        <li>법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
                      </ul>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              
              <div className="policy-section mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div className="me-3" style={{ color: 'var(--main-color)' }}>
                    <FaUserCog size={28} />
                  </div>
                  <h3 className="mb-0">6. 이용자 및 법정대리인의 권리와 그 행사방법</h3>
                </div>
                
                <div className="ps-md-5 ms-md-2">
                  <p>
                    이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며 가입해지를 요청할 수도 있습니다.
                    개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체없이 조치하겠습니다.
                  </p>
                </div>
              </div>
              
              <div className="policy-section mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div className="me-3" style={{ color: 'var(--main-color)' }}>
                    <FaCookieBite size={28} />
                  </div>
                  <h3 className="mb-0">7. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</h3>
                </div>
                
                <div className="ps-md-5 ms-md-2">
                  <p>
                    회사는 이용자에게 특화된 맞춤서비스를 제공하기 위해서 이용자들의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버(HTTP)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의 하드디스크에 저장되기도 합니다.
                  </p>
                  <Card className="border-light">
                    <Card.Body>
                      <Row>
                        <Col md={6}>
                          <div className="mb-3 mb-md-0">
                            <h5 className="mb-3" style={{ color: 'var(--main-color)' }}>쿠키의 사용 목적</h5>
                            <p className="mb-0">이용자들이 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다.</p>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div>
                            <h5 className="mb-3" style={{ color: 'var(--main-color)' }}>쿠키의 설치/운영 및 거부</h5>
                            <p className="mb-0">이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 이용자는 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.</p>
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              
              <div className="policy-section mb-5">
                <div className="d-flex align-items-center mb-4">
                  <div className="me-3" style={{ color: 'var(--main-color)' }}>
                    <FaHeadset size={28} />
                  </div>
                  <h3 className="mb-0">8. 개인정보에 관한 민원서비스</h3>
                </div>
                
                <div className="ps-md-5 ms-md-2">
                  <p>
                    회사는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보관리책임자를 지정하고 있습니다.
                  </p>
                  <Card className="border-light mb-3">
                    <Card.Body>
                      <div className="mb-4">
                        <h5 className="mb-3" style={{ color: 'var(--main-color)' }}>개인정보 관리책임자</h5>
                        <ul className="list-unstyled mb-0">
                          <li>• 성명: 원성준</li>
                          <li>• 전화번호: 02-2680-1080</li>
                          <li>• 이메일: binaida@binaida.co.kr</li>
                        </ul>
                      </div>
                      
                      <div>
                        <h5 className="mb-3" style={{ color: 'var(--main-color)' }}>기타 개인정보침해에 대한 신고 또는 상담</h5>
                        <ul className="list-unstyled mb-0">
                          <li>• 개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)</li>
                          <li>• 대검찰청 사이버수사과 (www.spo.go.kr / 국번없이 1301)</li>
                          <li>• 경찰청 사이버안전국 (cyberbureau.police.go.kr / 국번없이 182)</li>
                        </ul>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              
              <div className="policy-section">
                <div className="d-flex align-items-center mb-4">
                  <div className="me-3" style={{ color: 'var(--main-color)' }}>
                    <FaBullhorn size={28} />
                  </div>
                  <h3 className="mb-0">9. 고지의 의무</h3>
                </div>
                
                <div className="ps-md-5 ms-md-2">
                  <p>
                    현 개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 최소 7일전부터 홈페이지의 '공지사항'을 통해 고지할 것입니다.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
          
          {/* 푸터 섹션 */}
          <div className="text-center mt-5 pt-4 border-top">
            <p className="text-muted mb-1">
              <strong>공고일자:</strong> {new Date().toLocaleDateString()}
            </p>
            <p className="text-muted">
              <strong>시행일자:</strong> {new Date().toLocaleDateString()}
            </p>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default PrivacyPolicy;